import { render, staticRenderFns } from "./GraficoTrendComponent.vue?vue&type=template&id=0236b05e&scoped=true&"
import script from "./GraficoTrendComponent.vue?vue&type=script&lang=js&"
export * from "./GraficoTrendComponent.vue?vue&type=script&lang=js&"
import style0 from "./GraficoTrendComponent.vue?vue&type=style&index=0&id=0236b05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236b05e",
  null
  
)

export default component.exports